var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("wrapper", [
    _c(
      "section",
      { staticClass: "account-page" },
      [
        _vm.countriesLoaded && _vm.userLoaded
          ? _c("user-form", {
              attrs: {
                countries: _vm.countries,
                collections: _vm.availableCollections,
                publishers: _vm.availablePublishers,
                "show-job-role": _vm.user && _vm.user.user_type === "enterprise"
              },
              on: { validated: _vm.updateAccount },
              model: {
                value: _vm.form,
                callback: function($$v) {
                  _vm.form = $$v
                },
                expression: "form"
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }